<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Integrada"
        class="logo"
      />

      <div class="texts">
        <h2>Verifique seu e-mail.</h2>
        <p>
          Acabamos de enviar um e-mail para
          <b>{{ email }}</b> com o código para redefinir sua senha,
          <b>válido por 1 hora.</b>
        </p>
        <br />
        <p>
          Caso não encontre a mensagem na sua caixa de entrada, lembre-se de
          conferir o spam.
        </p>
        <br />
        <p>
          Ainda não recebeu?
          <button mat-button style="color: #4f86cf" (click)="reenvioCodigo()">
            Solicite o reenvio!
          </button>
        </p>
      </div>

      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
